module.exports = __webpack_public_path__ + "static/media/sledding.dbf88daf.svg";